import Sidebar from '../components/Sidebar';
import { Mail, MessageSquare, Phone } from 'lucide-react';

export default function Support() {
  return (
    <div className="flex min-h-screen bg-zinc-950" data-testid="support-page">
      <Sidebar />
      
      <main className="flex-1 md:ml-64 p-4 md:p-6 lg:p-8">
        <div className="mb-8">
          <h1 className="text-3xl sm:text-4xl font-bold text-white mb-2">Suporte</h1>
          <p className="text-slate-400">Entre em contato conosco</p>
        </div>

        <div className="max-w-2xl">
          <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-8">
            <h2 className="text-2xl font-bold text-white mb-6">Como podemos ajudar?</h2>
            
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="p-3 bg-emerald-600/10 border border-emerald-500/30 rounded-lg">
                  <MessageSquare className="w-6 h-6 text-emerald-500" />
                </div>
                <div>
                  <h3 className="text-lg font-bold text-white mb-2">WhatsApp</h3>
                  <p className="text-slate-400 mb-2">Entre em contato via WhatsApp para suporte rápido</p>
                  <a 
                    href="https://wa.me/5511999999999" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-emerald-500 hover:text-emerald-400 font-medium"
                    data-testid="whatsapp-support-link"
                  >
                    +55 11 99999-9999
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="p-3 bg-green-600/10 border border-green-500/30 rounded-lg">
                  <MessageSquare className="w-6 h-6 text-green-500" />
                </div>
                <div>
                  <h3 className="text-lg font-bold text-white mb-2">WhatsApp</h3>
                  <p className="text-slate-400 mb-2">Nos envie uma mensagem no WhatsApp</p>
                  <a 
                    href="https://wa.me/5561999999999" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-green-500 hover:text-green-400 font-medium"
                    data-testid="whatsapp-support-link"
                  >
                    +55 61 99999-9999
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="p-3 bg-violet-600/10 border border-violet-500/30 rounded-lg">
                  <Mail className="w-6 h-6 text-violet-500" />
                </div>
                <div>
                  <h3 className="text-lg font-bold text-white mb-2">Email</h3>
                  <p className="text-slate-400 mb-2">Envie um email para nossa equipe</p>
                  <a 
                    href="mailto:suporte@meugestor.com" 
                    className="text-violet-500 hover:text-violet-400 font-medium"
                    data-testid="email-support-link"
                  >
                    suporte@meugestor.com
                  </a>
                </div>
              </div>
            </div>

            <div className="mt-8 p-4 bg-slate-800/50 rounded-lg">
              <p className="text-sm text-slate-400">
                <strong className="text-white">Horário de atendimento:</strong><br />
                Segunda a Sexta: 9h - 18h<br />
                Sábado: 9h - 13h
              </p>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
